import wireframeDatePicker from '../assets/icons/wireframeDatePicker.svg';
import WireframeInputField from './WireframeInputField';
import { type IconData } from '../types';

class WireframeDatePicker extends WireframeInputField {
  initItems(): void {
    this.addDropdownItems();
    if (!this.label) {
      this.addLabel({ value: 'Pick a date', position: 'outside' });
    }
    if (!this.placeholder) {
      const date = new Date();
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      };
      const formattedDate = date.toLocaleDateString('en-US', options);
      this.addPlaceholder({
        value: formattedDate,
        state: 'text',
        iconRight: { prefix: 'fas', iconName: 'calendar-days' } as IconData,
      });
    }
  }

  static iconSvg() {
    return wireframeDatePicker;
  }

  static externalName(): string {
    return 'Date picker';
  }
}

export default WireframeDatePicker;
